import {svgIconWrapper} from '../svg-icon-wrapper';

import FreshcallerRegular from './freshcaller-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <FreshcallerRegular {...props} />;
}

SvgComponent.iconName = 'freshcallerRegular';

export const FreshcallerRegularIcon = svgIconWrapper(SvgComponent);
